import { render } from "./pb-spacer.vue?vue&type=template&id=ce1afad2"
import script from "./pb-spacer.vue?vue&type=script&lang=js"
export * from "./pb-spacer.vue?vue&type=script&lang=js"

import "./pb-spacer.vue?vue&type=style&index=0&id=ce1afad2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__